import * as React from "react";
import { forwardRef } from "react";
const SvgDefault = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2.5, d: "M5 19 19 5m0 14L5 5" }));
const ForwardRef = forwardRef(SvgDefault);
export { ForwardRef as ReactComponent };
